import { ssv2340ConfiCrtorWsResource } from '@/shared/api.resource';

import {
  FETCH_SSV2340_CONFI_CRTOR_WS_BY_ID,
  FETCH_PAGINATED_SSV2340_CONFI_CRTOR_WSS,
  UPDATE_SSV2340_CONFI_CRTOR_WS,
  CREATE_SSV2340_CONFI_CRTOR_WS,
  DELETE_SSV2340_CONFI_CRTOR_WS,
  RESET_SSV2340_CONFI_CRTOR_WS_FILTERS,
  RESET_SSV2340_CONFI_CRTOR_WS,
  RESET_SSV2340_CONFI_CRTOR_WSS_LIST,
} from './actions.type';

import {
  SET_SSV2340_CONFI_CRTOR_WS,
  SET_PAGINATED_SSV2340_CONFI_CRTOR_WSS,
  RESET_STATE_SSV2340_CONFI_CRTOR_WS_FILTERS,
  RESET_STATE_SSV2340_CONFI_CRTOR_WS,
  RESET_STATE_SSV2340_CONFI_CRTOR_WS_LIST,
} from './mutations.type';

const initialState = {
  ssv2340ConfiCrtorWsFilters: {},
  ssv2340ConfiCrtorWs: {},
  paginatedSsv2340ConfiCrtorWss: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2340_CONFI_CRTOR_WS_BY_ID](context, id) {
    const { data } = await ssv2340ConfiCrtorWsResource.get({ id: id });
    context.commit(SET_SSV2340_CONFI_CRTOR_WS, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2340_CONFI_CRTOR_WSS](context, params) {
    const { data } = await ssv2340ConfiCrtorWsResource.query(params);
    context.commit(SET_PAGINATED_SSV2340_CONFI_CRTOR_WSS, data);
    return data;
  },
  async [CREATE_SSV2340_CONFI_CRTOR_WS](context) {
    const { data } = await ssv2340ConfiCrtorWsResource.save(state.ssv2340ConfiCrtorWs);
    context.commit(SET_SSV2340_CONFI_CRTOR_WS, data);
    return data;
  },
  async [UPDATE_SSV2340_CONFI_CRTOR_WS](context, id) {
    const { data } = await ssv2340ConfiCrtorWsResource.update({ id: id }, state.ssv2340ConfiCrtorWs);
    context.commit(SET_SSV2340_CONFI_CRTOR_WS, data);
    return data;
  },
  [DELETE_SSV2340_CONFI_CRTOR_WS](context, id) {
    return ssv2340ConfiCrtorWsResource.delete({ id: id });
  },
  [RESET_SSV2340_CONFI_CRTOR_WS_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2340_CONFI_CRTOR_WS_FILTERS);
  },
  [RESET_SSV2340_CONFI_CRTOR_WS]({ commit }) {
    commit(RESET_STATE_SSV2340_CONFI_CRTOR_WS);
  },
  [RESET_SSV2340_CONFI_CRTOR_WSS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2340_CONFI_CRTOR_WS_LIST);
  }
};

export const mutations = {
  [SET_SSV2340_CONFI_CRTOR_WS](state, ssv2340ConfiCrtorWs) {
    state.ssv2340ConfiCrtorWs = ssv2340ConfiCrtorWs;
  },
  [SET_PAGINATED_SSV2340_CONFI_CRTOR_WSS](state, paginatedSsv2340ConfiCrtorWss) {
    state.paginatedSsv2340ConfiCrtorWss = paginatedSsv2340ConfiCrtorWss;
  },
  [RESET_STATE_SSV2340_CONFI_CRTOR_WS](state) {
    state.ssv2340ConfiCrtorWs = JSON.parse(JSON.stringify(initialState.ssv2340ConfiCrtorWs));
  },
  [RESET_STATE_SSV2340_CONFI_CRTOR_WS_FILTERS](state) {
    state.ssv2340ConfiCrtorWsFilters = JSON.parse(JSON.stringify(initialState.ssv2340ConfiCrtorWsFilters));
  },
  [RESET_STATE_SSV2340_CONFI_CRTOR_WS_LIST](state) {
    state.paginatedssv2340ConfiCrtorWss = JSON.parse(JSON.stringify(initialState.paginatedSsv2340ConfiCrtorWss));
  }
};

export const getters = {
  ssv2340ConfiCrtorWs(state) {
    return state.ssv2340ConfiCrtorWs;
  },
  ssv2340ConfiCrtorWsFilters(state) {
    return state.ssv2340ConfiCrtorWsFilters;
  },
  paginatedSsv2340ConfiCrtorWss(state) {
    return state.paginatedSsv2340ConfiCrtorWss;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}